<template>
  <div :class="[blueviolet ? 'text-blueviolet' : 'text-white', className, 'VBANK-logo text-uppercase']">
    <span class="font-weight-bold">v</span>
    <span class="font-weight-light">bank</span>
  </div>
</template>

<script>
  export default {
    name: 'Logo',
    props: {
      className: {
        type: String,
        default: '',
      },
      blueviolet: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" src="./Logo.scss" />
